import loadable from '@loadable/component'
import { PageContentQuery } from '@types'
import Header from 'components/Header'
import { THeaderType } from 'components/Header/Header'
import { PageProps, Script } from 'gatsby'
import useCookiesPolicy from 'hooks/useCookiesPolicy'
import useLocale from 'hooks/useLocale'
import React, { FC, JSXElementConstructor, ReactElement, cloneElement, useEffect } from 'react'

import 'react-tooltip/dist/react-tooltip.css'
import { DefaultPageProps } from 'src/app/wrapPageElement'
import { GlobalStyle } from 'theme'

import { emptyHeaderPage, isEmptyHeaderPage } from '@constants'
import styled from 'styled-components'
import { usePageType } from '../../hooks'
import { useTheme } from '@margex/ui'
import { setLocaleToLocalStorage } from 'utils/setLocaleToLocalStorage'
import { FreshchatProvider } from '../../providers/FreshchatProvider'

const Footer = loadable(() => import('components/Footer'))
const Proposal = loadable(() => import('components/Proposal'))

const inBrowser = typeof window !== 'undefined'

const DefaultLayout: FC<PageProps<PageContentQuery, DefaultPageProps, any, any>> = props => {
  const { data, footers, privacyLinks, footerWarning, general, uniqTitle, pageLocales } = props.pageContext
  const theme = useTheme()

  const children = props.children as unknown as ReactElement<any, string | JSXElementConstructor<any>>
  const { locale, pathname } = useLocale()

  const isStaking = pathname === '/staking'
  const type: THeaderType = usePageType()

  useCookiesPolicy(emptyHeaderPage)

  useEffect(() => {
    setLocaleToLocalStorage(locale)

    if (locale === 'fa') {
      document.dir = 'rtl'
      theme.direction = 'rtl'
    } else {
      document.dir = 'ltr'
    }
  }, [locale])

  return (
    <>
      {isStaking && (
        <noscript>
          <iframe
            title='Google Tag Manager'
            src='https://www.googletagmanager.com/ns.html?id=GTM-5J8DXCH'
            height='0'
            width='0'
            style={{ display: 'none', visibility: 'hidden' }}></iframe>
        </noscript>
      )}
      <GlobalStyle />
      {data && data.top_text && <Proposal data={data} />}
      <BackgroundContainer $type={type}>
        <Header translate={general?.attributes?.JSON} type={type} pageLocales={pageLocales} />
        {cloneElement(children, props)}
        {!isEmptyHeaderPage(pathname) && (
          <Footer
            footers={footers}
            privacyLinks={privacyLinks}
            footerWarning={footerWarning?.attributes?.JSON}
            type={type}
          />
        )}
      </BackgroundContainer>
      {inBrowser && !isEmptyHeaderPage(pathname) ? <FreshchatProvider /> : null}
      {uniqTitle === 'Staking' && (
        <>
          {/* <style>{`.async-hide { opacity: 0 !important}`}</style> */}
          <Script id='staking_script_id2'>{`(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
        h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
        (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
      })(window,document.documentElement,'async-hide','dataLayer',2000,
      {'GTM-5J8DXCH':true});`}</Script>
          <Script id='staking_script_id3'>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-5J8DXCH');`}</Script>
        </>
      )}
    </>
  )
}

export default DefaultLayout

const BackgroundContainer = styled.div<{ $type: THeaderType }>`
  background-color: ${({ $type, theme: { colors } }) =>
    $type === 'secondary' ? colors.newDarkColor.darkBlue : colors.white};
`
